import _ from "lodash";
import { appConfig } from "config/initializers/config.app";

/*
 * Actions
 */
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SESSION = "SESSION";
export const FORGOTPASSW = "FORGOTPASSW";
export const OMNIAUTHLOGIN = "OMNIAUTHLOGIN";
export const UPDATE_CONFIG = "UPDATE_CONFIG";
export const GET_LICENSE = "GET_LICENSE";
export const ACCEPT_COOKIES = "ACCEPT_COOKIES";

/*
 * Action Creators
 */

function _login(status, err, data) {
    return {
        type: LOGIN,
        status,
        err,
        data,
    };
}

function _logout(status, err, data) {
    return {
        type: LOGOUT,
        status,
        err,
        data,
    };
}

function _session(status, err, data) {
    return {
        type: SESSION,
        status,
        err,
        data,
    };
}

function _omniauthLogin(status, err, data) {
    return {
        type: OMNIAUTHLOGIN,
        status,
        err,
        data,
    };
}
function _updateConfig(status, err, data) {
    return {
        type: UPDATE_CONFIG,
        status,
        err,
        data,
    };
}
function _getLicense(status, err, data) {
    return {
        type: GET_LICENSE,
        status,
        err,
        data,
    };
}

export const preprocessLoginDetails = (firstField, passwordField) => {
    let processedFirstField = _.chain(firstField).trim().value();
    const processedPasswordField = _.chain(passwordField)
        .split(" ")
        .join("")
        .value();

    return {
        processedFirstField,
        processedPasswordField,
    };
};

export const validateLoginDetails = (firstField, firstFieldType) => {
    let errorMessage = null;
    if (
        firstFieldType &&
        firstFieldType === "email" &&
        !_.includes(firstField, "@")
    ) {
        errorMessage =
            "Email is invalid format, please check the email you have entered.";
    }
    return errorMessage;
};

function registerUser(name, email, password) {
    return (dispatch, getState, Request) => {
        let modEmail = _.chain(email).trim().toLower().value();
        let nameSplit = name.split(" ");
        return Request.fetch(appConfig.endpoints.createUserPath, {
            method: "POST",
            body: JSON.stringify({
                email: modEmail,
                password: password,
                first_name: _.startCase(_.toLower(nameSplit[0])),
                last_name:
                    nameSplit[1] === undefined
                        ? " "
                        : _.startCase(_.toLower(nameSplit[1])),
                username: modEmail,
                license: {
                    license_type: "Creator",
                    maxUsers: 10000000,
                    maxSpace: 100000000,
                },
            }),
        })
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve(userData);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

function login(firstField, password, apiURL) {
    return (dispatch, getState, Request) => {
        let formData = new FormData();
        let loginDetails = preprocessLoginDetails(firstField, password);
        const validateLoginDetail = validateLoginDetails(
            firstField,
            "username"
        );
        if (!validateLoginDetail) {
            formData.append("username", loginDetails.processedFirstField);
            formData.append("password", loginDetails.processedPasswordField);
            const loginPath = appConfig.endpoints.emailSignInPath;
            return Request.fetch(
                loginPath,
                {
                    method: "POST",
                    body: formData,
                },
                apiURL
            )
                .then((response) => {
                    return response.json();
                })
                .then((userData) => {
                    return dispatch(
                        _login("success", null, {
                            id: userData._id,
                            email: userData.email,
                            uid: userData._id,
                            provider: "MANUAL",
                            username: userData.username,
                            first_name: userData.first_name,
                            last_name: userData.last_name,
                            user_active: userData.active,
                            isUserLoggedIn: true,
                            createdAt: userData.createdAt,
                            license: userData.license,
                            details: userData.details,
                            profile: userData.profile,
                            image: userData.image,
                            logo: userData.logo,
                            client: {
                                appConfiguration: userData.branding,
                            },
                        })
                    );
                })
                .catch((err) => {
                    dispatch(_login("error", err, null));
                    return Promise.reject(err);
                });
        } else {
            return Promise.resolve({
                status: 500,
                errors: [validateLoginDetail],
            });
        }
    };
}

function tokenLogin(token) {
    return (dispatch, getState, Request) => {
        const loginPath = appConfig.endpoints.tokenSignInPath;
        return Request.fetch(loginPath, {
            method: "POST",
            headers: {
                authtoken: token,
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return dispatch(
                    _login("success", null, {
                        id: userData._id,
                        email: userData.email,
                        uid: userData._id,
                        provider: "MANUAL",
                        username: userData.username,
                        first_name: userData.first_name,
                        last_name: userData.last_name,
                        user_active: userData.active,
                        isUserLoggedIn: true,
                        createdAt: userData.createdAt,
                        license: userData.license,
                        details: userData.details,
                        profile: userData.profile,
                        image: userData.image,
                        logo: userData.logo,
                        client: {
                            appConfiguration: userData.branding,
                        },
                    })
                );
            })
            .catch((err) => {
                dispatch(_login("error", err, null));
                return Promise.reject(err);
            });
    };
}

function checkCaptcha(token) {
    return (dispatch, getState, Request) => {
        const checkCaptchaPath = appConfig.endpoints.checkCaptchaPath;
        return Request.fetch(checkCaptchaPath, {
            method: "POST",
            body: JSON.stringify({
                token: token,
            }),
        })
            .then((response) => {
                return response.json();
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function forgotPassword(email) {
    return (dispatch, getState, Request) => {
        const passwChangePath = appConfig.endpoints.emailForgotPasswordPath;
        return Request.fetch(passwChangePath, {
            method: "POST",
            body: JSON.stringify({
                email: _.chain(email).trim().toLower().value(),
            }),
        })
            .then((response) => {
                return response.json();
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

function logout() {
    return (dispatch, getState, Request) => {
        dispatch(_logout("fetching"));
        const logoutPath = appConfig.endpoints.signOutPath;
        return Request.fetch(logoutPath, {
            method: "POST",
            body: "",
        })
            .then(() => {
                Request.resetToken();
            })
            .then(() => {
                return dispatch(_logout("success"));
            })
            .catch((err) => {
                // If some errors still log him out of application
                Request.resetToken();
                return dispatch(_logout("error", err));
            });
    };
}

function session() {
    return (dispatch, getState, Request) => {
        return Promise.resolve(dispatch(_session()));
    };
}

function omniAuthLogin(userDetail) {
    return (dispatch, getState, Request) => {
        const accessToken = userDetail["access_token"];
        Request.setToken(
            accessToken["access-token"],
            accessToken.client,
            accessToken.expiry,
            accessToken["token-type"],
            accessToken.uid
        );
        return Promise.resolve(
            dispatch(
                _omniauthLogin(
                    "success",
                    null,
                    _.omit(userDetail, "access-token")
                )
            )
        );
    };
}

function updateConfig(configHash) {
    return (dispatch, getState, Request) => {
        const updateConfigPath = appConfig.endpoints.updateConfigPath.replace(
            ":id",
            getState().auth.user.client.id
        );
        return Promise.resolve(
            dispatch(
                _updateConfig("success", null, {
                    partConfig: configHash,
                })
            )
        ).then(() => {
            return Request.fetch(updateConfigPath, {
                method: "PATCH",
                body: JSON.stringify({
                    client: {
                        name: getState().auth.user.client.name,
                        app_configuration: configHash,
                    },
                }),
            })
                .then((response) => {
                    return response.json();
                })
                .then((resp) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
}

function getLicense() {
    return (dispatch, getState, Request) => {
        const getLicensePath = appConfig.endpoints.getLicensePath.replace(
            ":id",
            getState().auth.user.license.id
        );

        return Request.fetch(getLicensePath)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return Promise.resolve(
                    dispatch(
                        _getLicense("success", null, {
                            license: data,
                        })
                    )
                );
            })
            .catch((err) => {
                console.log(err);
            });
    };
}
class AuthenticationAction {
    static checkCaptcha = checkCaptcha;
    static registerUser = registerUser;
    static login = login;
    static logout = logout;
    static session = session;
    static forgotPassword = forgotPassword;
    static omniAuthLogin = omniAuthLogin;
    static tokenLogin = tokenLogin;
    static updateConfig = updateConfig;
    static getLicense = getLicense;
}

export { AuthenticationAction };
